import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import MoreVert from "@material-ui/icons/MoreVert";
import { TableRow, TableCell, Button, TextField } from "@material-ui/core";

import Options from "./options";

const ENVOZ_GROUP_ID = 421;

const RowTable = props => {
  const { isItemSelected, row } = props;
  const [anchorEl, setAnchorEl] = useState(undefined);
  const [menuState, setMenuState] = useState(false);

  const openMenuOptions = event => {
    setMenuState(true);
    setAnchorEl(event.currentTarget);
  };
  const closeMenuOptions = () => {
    setMenuState(false);
  };

  const hasEnvozGroup = Array.isArray(row.groups) && row.groups.includes(ENVOZ_GROUP_ID);

  return (
    <TableRow
      hover
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      selected={isItemSelected}
    >
      <TableCell align="left">
        {hasEnvozGroup && (
          <img
            src="https://envoz.mx/assets/blue-main-logo-DMX3mj83.png"
            alt="Envoz"
            style={{ height: 28, objectFit: 'contain' }}
          />
        )}
      </TableCell>
      <TableCell align="left">{row.title || "No registrado"}</TableCell>
      <TableCell align="left">{row.limit_registers || "No registrado"}</TableCell>
      <TableCell align="center">{row.amount}</TableCell>
      <TableCell align="left">{row.social_network_name || "No registrado"}</TableCell>
      <TableCell align="left">
        <span style={{
          background: row.active == 1 ? '#e6f4ea' : '#fce8e6',
          color: row.active == 1 ? '#1e7e34' : '#c0392b',
          borderRadius: 12,
          padding: '2px 10px',
          fontWeight: 600,
          fontSize: 12,
        }}>
          {row.active == 1 ? 'Activa' : 'Inactiva'}
        </span>
      </TableCell>
      <TableCell align="right">
        <IconButton onClick={openMenuOptions}>
          <MoreVert />
        </IconButton>
        <Options
          menuState={menuState}
          anchorEl={anchorEl}
          handleRequestClose={closeMenuOptions}
          data={row}
          id={row.id}
          active={row.active}
        />
      </TableCell>
    </TableRow>
  );
};

export default RowTable;
